const SVGComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m15.56 7.847-.003-.014-1.973-5.011a.68.68 0 0 0-.646-.478H4.943a.68.68 0 0 0-.649.485L2.45 7.789l-.005.013-.003.014a.7.7 0 0 0-.018.26l-.003.084v6.432a1.07 1.07 0 0 0 1.068 1.069h11.025c.59 0 1.07-.48 1.07-1.069V8.095a.7.7 0 0 0-.024-.248m-5.2-.755-.005.276c-.014.789-.559 1.32-1.355 1.32-.388 0-.722-.125-.963-.362-.241-.238-.373-.568-.38-.958l-.005-.276H4.034l1.398-3.398h7.017l1.436 3.398zm-6.59 1.35h2.765c.427 1.003 1.336 1.596 2.468 1.596a2.74 2.74 0 0 0 1.587-.478c.39-.275.694-.658.891-1.118h2.751v5.869H3.77z"
      fill="currentColor"
    />
  </svg>
);
export default SVGComponent;
